import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CampaignsIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Campaigns",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M25.72 19.65 21.46 6.22a.9.9 0 0 0-1.13-.58c-.06.02-.12.04-.17.07L1.46 16.45c-.37.21-.54.65-.42 1.06l1.5 4.71c.13.41.53.67.95.62l3.48-.38c.32 2.4 2.16 4.14 4.13 3.92s3.37-2.32 3.16-4.72l10.71-.86c.49-.05.84-.49.79-.98 0-.06-.02-.12-.04-.17m-14.8 5.15c-1.21.14-2.34-.96-2.56-2.46l4.51-.5c.12 1.48-.74 2.78-1.95 2.95Zm15.4-12.34a.74.74 0 0 1-.75-.74c0-.33.21-.62.53-.72l3.94-1.24c.4-.12.81.1.94.5s-.1.81-.5.94l-3.94 1.22a.9.9 0 0 1-.22.04m-1.7-2.27c-.17 0-.33-.06-.46-.16a.747.747 0 0 1-.11-1.05l1.86-2.3a.748.748 0 0 1 1.17.93l-1.86 2.31c-.15.17-.36.27-.58.27Zm4.64 6.02a.8.8 0 0 1-.22 0l-2.77-.93a.745.745 0 0 1 .47-1.41l2.74.89a.742.742 0 0 1-.21 1.45Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M22.2 10.41c-.29 0-.58-.11-.81-.33a1.14 1.14 0 0 1 0-1.62l2.83-2.83a1.14 1.14 0 0 1 1.62 0c.45.45.45 1.17 0 1.62l-2.83 2.83c-.22.22-.52.33-.81.33M16.98 8.09a1.145 1.145 0 0 1-1.11-1.44l1.06-3.95c.16-.61.79-.97 1.4-.81s.97.79.81 1.4l-1.06 3.95c-.14.51-.6.85-1.1.85M24.51 15.63a1.145 1.145 0 0 1-.29-2.25l3.62-.97c.61-.16 1.24.2 1.4.81s-.2 1.24-.81 1.4l-3.62.97c-.1.03-.2.04-.3.04M25.86 24.71H13.29a1.14 1.14 0 1 1 0-2.28h9.81L6.76 6.09a1.14 1.14 0 0 1 0-1.62 1.14 1.14 0 0 1 1.62 0l18.29 18.29c.33.33.42.82.25 1.25-.18.43-.59.71-1.06.71Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M7.57 18.99c-.63 0-1.14-.51-1.14-1.14v-5.71a1.14 1.14 0 1 1 2.28 0v5.71c0 .63-.51 1.14-1.14 1.14"
      }), /*#__PURE__*/_jsx("path", {
        d: "M8.71 29.28c-.3 0-.59-.12-.81-.33l-5.71-5.71a1.14 1.14 0 0 1 0-1.62l4.57-4.57a1.14 1.14 0 0 1 1.62 0l5.71 5.71c.45.45.45 1.17 0 1.62l-4.57 4.57c-.21.21-.5.33-.81.33m-4.09-6.86 4.1 4.1 2.96-2.96-4.1-4.1z"
      })]
    })
  }));
};
CampaignsIcon.displayName = 'CampaignsIcon';